import { useEffect, useState } from 'react';
import { Button, Input, Spin, Switch, Tag, Typography, message } from 'antd';

const { Text } = Typography;

export default function CreatePlaylistDrawer({
  open,
  onClose,
  onSubmit, // (payload) => Promise<void>
  // données pour le récap :
  depts = [], // ex: ["75","92"]
  deptList = [], // ex: [{code:"75", nom:"Paris"}, ...]
  communes = [], // ex: [{id, nom, cp}]
  activityItems = [], // buildActivitySummary(...) -> [{key,label,type,codes:[...]}, ...]
  // options
  emailOnly = true, // imposé à true
  onEdit, // ← NEW: (tabKey: "geo" | "activity") => void
}) {
  const [creating, setCreating] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    if (open) {
      setCreating(false);
      setName('');
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = async () => {
    if (!name.trim()) {
      message.warning('Veuillez saisir un nom de playlist.');
      return;
    }
    if (!emailOnly) {
      message.warning(
        'La création nécessite des e-mails. Activez l’option correspondante.'
      );
      return;
    }
    setCreating(true);
    try {
      await onSubmit({ name: name.trim(), emailOnly: true });
    } finally {
      setCreating(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 3000 }}>
      {/* Backdrop */}
      <div
        style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,.4)' }}
        onClick={onClose}
        aria-hidden
      />

      {/* Panel */}
      <div
        role="dialog"
        aria-modal="true"
        style={{
          position: 'absolute',
          right: 0,
          top: 0,
          height: '100%',
          width: '100%',
          maxWidth: 560,
          background: '#fff',
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          borderLeft: '1px solid #e5e7eb',
        }}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            borderBottom: '1px solid #eee',
          }}
        >
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
            Créer une playlist
          </h2>
          <button
            onClick={onClose}
            style={{
              fontSize: 22,
              lineHeight: 1,
              border: 0,
              background: 'transparent',
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div
          style={{ padding: 16, overflow: 'auto', gap: 16, display: 'grid' }}
        >
          {/* Nom */}
          <div>
            <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>
              Nom de la playlist
            </div>
            <Input
              placeholder="Ex. Paris + 92 – Bâtiment"
              value={name}
              onChange={e => setName(e.target.value)}
              maxLength={120}
            />
          </div>

          {/* Email only (imposé) */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Switch checked disabled />
            <span>Avec e-mail uniquement (obligatoire)</span>
          </div>

          {/* Récap Géographie */}
          <div
            style={{
              background: '#fff',
              border: '1px solid #eee',
              borderRadius: 8,
              padding: 12,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
              }}
            >
              <Text strong>Géographie</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Modifier dans le panneau des filtres
              </Text>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {depts.map(code => (
                <Tag key={`dep-${code}`} color="volcano">
                  {deptList.find(d => d.code === code)?.nom || code} ({code})
                </Tag>
              ))}
              {communes.map(({ id, nom, cp }) => (
                <Tag key={`${id}-${cp}`} color="blue">
                  {nom} — {cp}
                </Tag>
              ))}
              {depts.length === 0 && communes.length === 0 && (
                <Text type="secondary">Aucune sélection géographique</Text>
              )}
              <Button size="small" type="link" onClick={() => onEdit?.('geo')}>
                Modifier
              </Button>
            </div>
          </div>

          <div
            style={{
              background: '#fff',
              border: '1px solid #eee',
              borderRadius: 8,
              padding: 12,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 8,
              }}
            >
              <Text strong>Activité</Text>
              <Text type="secondary" style={{ fontSize: 12 }}>
                Modifier dans le panneau des filtres
              </Text>
            </div>
            {activityItems?.length ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {activityItems.map(item => (
                  <Tag key={item.key}>{item.label}</Tag>
                ))}
              </div>
            ) : (
              <Text type="secondary">Aucune activité sélectionnée</Text>
            )}
            <Button
              size="small"
              type="link"
              onClick={() => onEdit?.('activity')}
            >
              Modifier
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            padding: 12,
            borderTop: '1px solid #eee',
          }}
        >
          <Button onClick={onClose}>Annuler</Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            disabled={creating || !emailOnly}
          >
            {creating ? <Spin size="small" /> : 'Créer'}
          </Button>
        </div>
      </div>
    </div>
  );
}
